/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PixtaStoredImage,
    PixtaStoredImageFromJSON,
    PixtaStoredImageFromJSONTyped,
    PixtaStoredImageToJSON,
} from './PixtaStoredImage';

/**
 * PIXTA画像ダウンロードAPIのレスポンスデータ
 * @export
 * @interface GetPixtaImageSuccessResponseData
 */
export interface GetPixtaImageSuccessResponseData {
    /**
     * サーバーに保存されたPIXTA画像のデータリスト
     * @type {Array<PixtaStoredImage>}
     * @memberof GetPixtaImageSuccessResponseData
     */
    images: Array<PixtaStoredImage>;
}

export function GetPixtaImageSuccessResponseDataFromJSON(json: any): GetPixtaImageSuccessResponseData {
    return GetPixtaImageSuccessResponseDataFromJSONTyped(json, false);
}

export function GetPixtaImageSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPixtaImageSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'images': ((json['images'] as Array<any>).map(PixtaStoredImageFromJSON)),
    };
}

export function GetPixtaImageSuccessResponseDataToJSON(value?: GetPixtaImageSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'images': ((value.images as Array<any>).map(PixtaStoredImageToJSON)),
    };
}

